<template lang="pug">
div(class="c-media-preview")
  div(class="c-media-preview__header")
    span(@click="onCloseClick()" data-testid="media-preview-close-button")
      BlIconAv(:icon="IcoCrossMinor")
  div(class="c-media-preview__body")
    //- Image Preview
    div(v-if="mediaType === 'image'" class="c-media-preview__item")
      img(:src="url" :alt="mediaType" data-testid="media-preview-image")
    //- Video Preview
    div(v-if="mediaType === 'video'" class="c-media-preview__item")
      video(controls data-testid="media-preview-video")
        source(:src="url" type="video/mp4" data-testid="media-preview-video-source")
</template>

<script>
import BlIconAv from '@bukalapak/bazaar-visual/dist/components/BlIconAv';
import IcoCrossMinor from '@bukalapak/bazaar-visual/dist/components/IcoCrossMinor';

export default {
  name: 'MediaPreview',
  components: {
    BlIconAv,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    mediaType: {
      type: String, // 'image' | 'video'
      required: true,
    },
  },
  data() {
    return {
      IcoCrossMinor,
    };
  },
  methods: {
    onCloseClick() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.c-media-preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 110;

  &__header {
    background-color: #fff;
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 16px;
  }

  &__body {
    background-color: #000;
    width: 100%;
    height: calc(100% - 60px);
    display: flex;
    align-items: center;
  }

  &__item {
    width: 100%;
    height: 50%;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }

    video {
      width: 100%;
      height: auto;
    }
  }
}
</style>
